<template>
    <div class="mt-3 mb-3">
        <b-row v-if="commodityAdded">
            <b-col>
                <b-form-group :label="$t('createShipment.aes.description')">
                    <b-form-input
                        v-model="commodity.description"
                        :placeholder="$t('createShipment.aes.description')"
                        size="sm"
                        type="text"
                        :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].description.$error }"
                    />
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].description.$anyDirty"
                    fieldName="createShipment.aes.description"
                    :validator="v.shipment.customsAmount.commodities.$each[index].description"
                />
            </b-col>
            <b-col>
                <b-form-group :label="$t('createShipment.aes.originCountry')">
                    <vSelect
                        v-model="commodity.countryOfManufacture"
                        :reduce="(country) => country.countryCode"
                        label="countryName"
                        :dynamicWidth="false"
                        :options="getCountries"
                        :placeholder="$t('createShipment.aes.country')"
                        :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].countryOfManufacture.$error }"
                    />
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].countryOfManufacture.$anyDirty"
                    fieldName="createShipment.aes.originCountry"
                    :validator="v.shipment.customsAmount.commodities.$each[index].countryOfManufacture"
                />
            </b-col>
            <b-col>
                <b-form-group :label="$t('createShipment.aes.scheduleB')">
                    <b-form-input
                        v-model="commodity.harmonizedCode"
                        :placeholder="$t('createShipment.aes.scheduleB')"
                        size="sm"
                        type="text"
                        :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].harmonizedCode.$error }"
                    />
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].harmonizedCode.$anyDirty"
                    fieldName="createShipment.aes.scheduleB"
                    :validator="v.shipment.customsAmount.commodities.$each[index].harmonizedCode"
                />
            </b-col>

            <b-col>
                <b-form-group :label="$t('createShipment.aes.weight')">
                    <b-input-group size="sm" append="kg">
                        <b-form-input
                            type="number"
                            v-model.number="commodity.unitWeight"
                            :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].unitWeight.$error }"
                        />
                    </b-input-group>
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].unitWeight.$anyDirty"
                    fieldName="createShipment.aes.weight"
                    :validator="v.shipment.customsAmount.commodities.$each[index].unitWeight"
                />
            </b-col>
            <b-col sm="1">
                <b-form-group :label="$t('createShipment.aes.quantity')">
                    <b-form-input
                        v-model.number="commodity.quantity"
                        size="sm"
                        type="number"
                        :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].quantity.$error }"
                    />
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].quantity.$anyDirty"
                    fieldName="createShipment.aes.quantity"
                    :validator="v.shipment.customsAmount.commodities.$each[index].quantity"
                />
            </b-col>
            <b-col>
                <b-form-group :label="$t('createShipment.aes.unitPrice')">
                    <b-input-group size="sm" :append="currencyCode">
                        <b-form-input
                            type="number"
                            size="sm"
                            :min="0"
                            v-model.number="commodity.unitPrice.amount"
                            :class="{ 'is-invalid': v.shipment.customsAmount.commodities.$each[index].unitPrice.amount.$error }"
                        />
                    </b-input-group>
                </b-form-group>
                <validationField
                    v-if="v.shipment.customsAmount.commodities.$each[index].unitPrice.amount.$anyDirty"
                    fieldName="createShipment.aes.unitPrice"
                    :validator="v.shipment.customsAmount.commodities.$each[index].unitPrice.amount"
                />
            </b-col>
            <div class="mt-4">
                <b-input-group-append
                    class="addPriceLineIcon"
                    v-if="index === 0"
                >
                    <font-awesome-icon
                        @click="$emit('add-aes-line', $event)"
                        icon="plus-circle"
                        size="lg"
                    />
                </b-input-group-append>

                <b-input-group-append v-if="index > 0" class="addPriceLineIcon">
                    <font-awesome-icon
                        @click="$emit('remove-aes-line', index)"
                        icon="minus-circle"
                        size="lg"
                    />
                </b-input-group-append>
            </div>
        </b-row>
    </div>
</template>

<script>
  import vSelect from '../vSelect';
  import { mapGetters } from 'vuex';
  import validationField from '../Validation/ValidationField';

  export default {
      data() {
          return {};
      },

      computed: {
          ...mapGetters('core', ['getCountries', 'getCurrencies']),

          commodityAdded() {
              return this.v.shipment.customsAmount.commodities.$model[this.index];
          },
      },

      props: {
          v: { required: true },
          index: { type: Number, required: true },
          commodity: { type: Object, required: true },
          currencyCode: { required: true },
      },

      components: {
          vSelect,
          validationField,
      },
  };
</script>
<style>
  .addPriceLineIcon {
      margin-right: 15px;
  }
</style>
